const normalizeHtml = html => html.replace("\n", "<br>");

export default normalizeHtml;
